<script>
import NavBar from '@/components/nav-bar.vue'
import RightBar from '@/components/right-bar.vue'
export default {
  data () {
    return {
      MQMessageLists: {
        title: '',
        time: '',
        content: ''
      }
    }
  },
  components: { NavBar, RightBar },
  watch: {
    $router (newRoy, oldRou) {
      console.log(newRoy)
      console.log(oldRou)
    }
  }
}
</script>

<template>
  <div class="container">
      <div class="micwareHeaderContainer" >
       <div class="headercontent">
            <!-- <div  class="header">头组件（布局测试） </div> -->
           <NavBar/>
           <slot/>
       </div>
       <RightBar>
         <!-- <div slot="rightbutton">
          <slot name="rightbtn"/>
         </div> -->
       </RightBar>
      </div>
  </div>

</template>

<style lang="scss" scoped>
@import "../../assets/css/C00.css";
.container {
  flex:1;
  display: flex;
  flex-direction: column;
  padding-right: 0px;
  padding-left: 0px;
  width: 100%;
  height: 100vh;

    .micwareHeaderContainer{
      flex: 1;
      display: flex;
      flex-direction: row;
      margin-left: 30px;
      margin-right: 30px;
      margin-bottom: 30px;
      background-color: #fff;
      border: 1px solid rgb(200, 200, 200);
      height: calc(100% - 30px);
      .headercontent{
        flex:1;
        display: flex;
        flex-direction: column;
        background-color: white;
      }
    }

  .footer{
    //height: 3vh; //4vh 50px;
    flex:0 0 30px; //3vh

  }

}
</style>



// WEBPACK FOOTER //
// src/router/layouts/mainLayout.vue